<template>
  <div class="group" v-if="show">
    <div class="box-size">
      <div class="sub-menu-overlay" @click="close()"></div>
    </div>
    <div class="box animated fadeIn">
      <div class="col-12 justify-content-end row mx-0">
        <div class="btn button-times" @click="close()">
          <span class="fa fa-times"></span>
        </div>
      </div>
      <div class="mx-0 row mt-2">
        <div class="col-12 text-center">
          <input
            class="input-type"
            type="text"
            v-model="form.name"
            placeholder="Nombre"
          />
          <div class="line-hover mx-auto"></div>
        </div>

        <div class="col-12 text-center mt-4">
          <input
            class="input-type"
            type="text"
            v-model="form.last_name"
            placeholder="Apellido"
          />
          <div class="line-hover mx-auto"></div>
        </div>

        <div class="col-12 text-center mt-4">
          <input
            class="input-type"
            type="text"
            v-model="form.email"
            placeholder="E-mail"
          />
          <div class="line-hover mx-auto"></div>
        </div>

        <div class="col-12 text-center mt-4 p-0">
          <vue-tel-input
            @country-changed="countryChanged"
            id="telInput"
            :validCharactersOnly="true"
            :placeholder="'Teléfono'"
            v-model="form.movil"
            class="mx-auto input-type pl-0"
          ></vue-tel-input>
          <div class="line-hover mx-auto"></div>
        </div>

        <div class="col-12 text-center mt-4">
          <textarea
            class="input-type"
            placeholder="¿En que te podemos ayudar?"
            v-model="form.message"
            name=""
            id=""
            cols="30"
            rows="5"
          ></textarea>
          <div class="line-hover mx-auto"></div>
        </div>

        <div class="col-12 text-center mt-4">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="defaultCheck1"
            @input="form.accept = !form.accept"
          />
          <label class="form-check-label" for="defaultCheck1">
            acepto términos y condiciones
          </label>
        </div>

        <button
          :disabled="validate"
          @click="sendComment"
          class="btn orange-btn mx-auto text-white"
        >
          ENVIAR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import { mapGetters } from "vuex";
import toastr from "toastr";

export default {
  name: "Contact",
  components: {
    VueTelInput,
  },
  props: {
    show: Boolean,
  },
  data: () => ({
    value: String,
    phoneCode: "",
    form: {
      name: "",
      last_name: "",
      email: "",
      movil: "",
      message: "",
      accept: false,
    },
  }),
  created() {
    this.reset();
  },
  mounted() {
    this.createField();
  },
  computed: {
    ...mapGetters({ user_geo_data: "auth/getUserGeoData" }),
    validate() {
      if (
        this.form.name == "" ||
        this.form.last_name == "" ||
        this.form.email == "" ||
        this.form.phone == "" ||
        this.form.message == ""
      ) {
        return true;
      }

      if (!this.form.accept) {
        return true;
      }

      let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!emailRegex.test(this.form.email)) {
        return true;
      }

      return false;
    },
  },
  methods: {
    countryChanged(event) {
      this.phoneCode = event.dialCode;
    },
    createField() {
      let div = document.createElement("div");
      div.classList.add("line-hover");
      document.getElementById("telInput").appendChild(div);
    },
    close() {
      this.$emit("close");
    },
    reset() {
      this.form = {
        name: "",
        last_name: "",
        email: "",
        movil: "",
        message: "",
        code_relation: 'contact_form',
        accept: false,
      };
    },
    sendComment() {
      let data = {
        ...this.form,
        ...this.user_geo_data,
      };

      data.movil = this.phoneCode + data.movil

      toastr.warning("Enviando...");

      this.$store.dispatch("auth/sendComent", data).then((data) => {
        toastr.clear();
        toastr.success("Mensaje Enviado");
        this.close()
      });
    },
  },
};
</script>

<style scoped>
.sub-menu-overlay {
  top: 0px;
  position: fixed;
  left: 0px;
  width: 100vw;
  height: 100%;
  z-index: 110;
  background: #446daf 0% 0% no-repeat padding-box;
  opacity: 0.6 !important;
  z-index: 9999;
  transition: fade-in 1s;
}

@keyframes fade-in {
  from {
    opacity: 0;
    /* transform: scaleX(0); */
  }

  to {
    opacity: 0.6;
    /* transform: scaleX(1); */
  }
}

.line-hover {
  background: transparent -webkit-gradient(
      linear,
      left top,
      right top,
      from(#f1946d),
      to(#de337a)
    ) 0% 0% no-repeat padding-box;
  height: 1.5px;
  width: 450px;
}

:focus {
  outline: none !important;
  border: none !important;
}

::v-deep .vue-tel-input > .vti__input ~ .line-hover,
.input-type ~ .line-hover {
  position: absolute;
  bottom: 0;
  left: 55px;
  width: 0;
  height: 1px;
}

.vti__dropdown {
  outline: none !important;
}

::v-deep .vue-tel-input > .vti__input:focus ~ .line-hover,
.input-type:focus ~ .line-hover {
  width: 450px;
  height: 2px;
  transition: 0.5s;
}

.open,
.open:active {
  outline: none !important;
  border: none;
  outline: none !important;
}

.form-check-label,
.input-type {
  color: #000000 !important;
}

.group {
  width: 100vh;
  height: 100%;
}

.box {
  z-index: 99999;
  width: 560px;
  position: fixed;
  height: 600px;
  background: #ffffff 0% 0% no-repeat padding-box;
  -webkit-box-shadow: 0px 5px 6px #00000029;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  top: calc((100vh - 600px) / 2);
  right: calc((100vw - 560px) / 2);
}

.button-times {
  width: 45px;
  height: 46px;
  background: transparent linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  margin-right: -25px;
  margin-top: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fa-times {
  color: white;
  font-size: 25px;
}

input {
  outline: none !important;
}

.vue-tel-input {
  height: 45px;
  width: 450px;
  border: none !important;
  border-bottom: 1px solid #a7a7a7 !important;
  outline: none !important;
  box-shadow: none !important;
}

.input-type {
  width: 450px;
  height: 45px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-bottom: 1px solid #a7a7a7;
  outline: none !important;
  padding-left: 20px;
  color: #000000;
}

textarea {
  width: 450px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-bottom: 1px solid #a7a7a7;
  outline: none !important;
  padding-left: 20px;
  color: #000000;
  padding-top: 20px;
  resize: none;
  height: 125px !important;
}

.orange-btn {
  width: 284px;
  height: 52px;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  font-size: 20px;
}

@media screen and (max-width: 760px) {
  .vue-tel-input > .vti__input:focus ~ .line-hover,
  .input-type:focus ~ .line-hover {
    width: 230px;
    height: 2px;
    transition: 0.5s;
  }

  .vue-tel-input > .vti__input ~ .line-hover,
  .input-type ~ .line-hover {
    left: 36px !important;
  }

  .box {
    width: 300px;
    right: calc((100vw - 300px) / 2);
  }

  .input-type,
  textarea,
  .vue-tel-input {
    width: 230px;
  }

  .line-hover {
    background: transparent -webkit-gradient(
        linear,
        left top,
        right top,
        from(#f1946d),
        to(#de337a)
      ) 0% 0% no-repeat padding-box;
    height: 1.5px;
    width: 230px;
  }

  .orange-btn {
    width: 208px;
    height: 38px;
    font: normal normal normal 17px/7px Roboto;
  }
}
</style>
<style >
@media screen and (max-width: 760px) {
  .vue-tel-input > .vti__input:focus ~ .line-hover,
  .input-type:focus ~ .line-hover {
    width: 230px;
    height: 2px;
    transition: 0.5s;
  }

  .vue-tel-input > .vti__input ~ .line-hover,
  .input-type ~ .line-hover {
    left: 36px !important;
  }

  .input-type,
  textarea,
  .vue-tel-input {
    width: 230px;
  }

  .line-hover {
    background: transparent -webkit-gradient(
        linear,
        left top,
        right top,
        from(#f1946d),
        to(#de337a)
      ) 0% 0% no-repeat padding-box;
    height: 1.5px;
    width: 230px;
  }
}

.vue-tel-input > .vti__input ~ .line-hover,
.input-type ~ .line-hover {
  position: absolute;
  bottom: 0;
  left: 55px;
  width: 50px;
  height: 1px;
}

.vti__dropdown {
  outline: none !important;
}

.vue-tel-input > .vti__input:focus ~ .line-hover,
.input-type:focus ~ .line-hover {
  width: 450px;
  height: 2px;
  transition: 0.5s;
}
.line-hover {
  background: transparent -webkit-gradient(
      linear,
      left top,
      right top,
      from(#f1946d),
      to(#de337a)
    ) 0% 0% no-repeat padding-box;
  height: 1.5px;
  width: 450px;
}
</style>